export default __webpack_public_path__ + "static/media/ORDI.546053a5.svg";